import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { isProd } from './app/core/constants';
import { App } from './app/app';
import './i18n';

if (isProd) {
  require('./index-prod.scss');
} else {
  require('./index.scss');
}

ReactDOM.render(<App />, document.querySelector('#root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
